import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { TruckOwnerService } from "../truck-owner.service";
import { ViewDriverRouteComponent } from "../view-driver-route/view-driver-route.component";
import { CreateDriverRouteComponent } from "../create-driver-route/create-driver-route.component";

@Component({
  selector: "app-driver-orders",
  templateUrl: "./driver-orders.component.html",
  styleUrls: ["./driver-orders.component.css"],
})
export class DriverOrdersComponent implements OnInit {
  tripType: any = "-1";
  fetch_page: any = 1;
  startPage: any = 1;
  last_page: any = 1;
  currentPage: any = 1;
  document_array: any = [];
  searchtripID: any = -1;
  token: any;
  perPage: any = 10;
  driverOrdersList: any = [];
  loading: boolean = false;
  searchButton: boolean = true;
  toggleSearch: boolean = false;
  allTrips: boolean = true;
  liveTrips: boolean = false;
  dr_Status: any = -1;
  search_query: any = -1;
  clear_Btn: boolean = false;
  isInputValid: boolean = false;
  previousValue: string = "";
  private lengthState: number = 0;
  search_Btn: boolean = true;
  matdialogRef!: MatDialogRef<ViewDriverRouteComponent>;
  createDialogRef!: MatDialogRef<CreateDriverRouteComponent>;

  @ViewChild("newItem") newItem!: ElementRef;
  @ViewChild("newItem", { static: false }) inputElement!: ElementRef;

  constructor(
    private matDialog: MatDialog,
    private services: TruckOwnerService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("to_token");
    if (!this.token) {
      this.router.navigateByUrl("/");
      return;
    }
    let triptype = "driverOrders";
    sessionStorage.setItem("tripType", triptype);

    const savedPage = sessionStorage.getItem("lastToDriverOrdersFetchPage");
    this.fetch_page = savedPage ? parseInt(savedPage) : 1;
    this.startPage = this.fetch_page;
    this.currentPage = this.fetch_page;

    this.getDriversRoutes(this.searchtripID);
  }

  onInputChange(input: HTMLInputElement) {
    const value = input.value;
    const previousLength = this.previousValue.length;
    this.previousValue = value;

    if (this.previousValue.length > previousLength && this.clear_Btn) {
      this.callApi();
      this.search_Btn = true;
      this.clear_Btn = false;
    }

    const containsSpecialChars = /[^\w\d]/.test(value);
    if (containsSpecialChars) {
      input.value = value.replace(/[^\w\d]/g, "");
      this.snackBar.open("Special characters are not allowed", "Fail", {
        duration: 5000,
      });
      return;
    }

    this.isInputValid = value.length >= 4;
    switch (previousLength) {
      case 10:
        if (value.length === 9 && this.lengthState !== 9) {
          this.lengthState = 9;
          this.callApi();
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;

      case 9:
        if (value.length === 8 && this.lengthState !== 8) {
          this.lengthState = 8;
          this.callApi();
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;

      case 8:
        if (value.length === 7 && this.lengthState !== 7) {
          this.lengthState = 7;
          this.callApi();
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;

      case 7:
        if (value.length === 6 && this.lengthState !== 6) {
          this.lengthState = 6;
          this.callApi();
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;

      case 6:
        if (value.length === 5 && this.lengthState !== 5) {
          this.lengthState = 5;
          this.callApi();
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;

      case 5:
        if (value.length === 4 && this.lengthState !== 4) {
          this.lengthState = 4;
          this.callApi();
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;

      case 4:
        if (value.length === 3 && this.lengthState !== 3) {
          this.lengthState = 3;
          this.callApi();
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;

      default:
        if (value.length >= 4) {
          this.lengthState = 0;
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;
    }

    if (value.length === 0) {
      this.resetSearch();
    }
  }

  resetSearch() {
    if (this.newItem && this.newItem.nativeElement) {
      this.newItem.nativeElement.value = "";
    }
    this.searchtripID = -1;
    this.fetch_page = 1;
    this.startPage = 1;
    this.getDriversRoutes(this.searchtripID);
    this.toggleSearch = false;
    this.searchButton = true;
    this.clear_Btn = false;
    this.search_Btn = true;
  }

  private callApi() {
    this.searchtripID = -1;
    this.fetch_page = 1;
    this.startPage = 1;
    this.getDriversRoutes(this.searchtripID);
  }

  getDriversRoutes(type: any) {
    this.loading = true;
    this.search_query = type;

    this.services
      .getDriverOrders(
        this.token,
        this.dr_Status,
        this.search_query,
        this.perPage,
        this.startPage,
        this.tripType
      )
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.driverOrdersList = response.body.data || [];
            this.document_array = [response.body.meta];
            this.last_page = response.body.meta?.lastPage || 1;
            this.loading = false;
          }
        },
        (error: any) => {
          this.driverOrdersList = [];
          this.loading = false;
          if (error.status === 404) {
            return;
          }
          if (
            error?.error?.message === "jwt malformed" ||
            error?.error?.message === "jwt expired" ||
            error?.error?.message === "invalid signature"
          ) {
            sessionStorage.clear();
            this.router.navigateByUrl("/");
          }
          if (error?.error?.message) {
            this.snackBar.open(error.error.message, "Fail", {
              duration: 5000,
            });
          }
        }
      );
  }

  openCreateDRO() {
    this.createDialogRef = this.matDialog.open(CreateDriverRouteComponent, {
      width: "90vw",
      maxWidth: "800px",
      data: {},
      autoFocus: false,
    });
    this.createDialogRef.afterClosed().subscribe((res: any) => {
      if (res && res.event === "Success") {
        this.getDriversRoutes(this.searchtripID);
      }
    });
  }

  editDRO(item: any) {
    this.createDialogRef = this.matDialog.open(CreateDriverRouteComponent, {
      width: "90vw",
      maxWidth: "800px",
      data: { isEdit: true, dro: item },
      autoFocus: false,
    });
    this.createDialogRef.afterClosed().subscribe((res: any) => {
      if (res && res.event === "Success") {
        this.getDriversRoutes(this.searchtripID);
      }
    });
  }

  viewDriver(item: any) {
    this.matdialogRef = this.matDialog.open(ViewDriverRouteComponent, {
      width: "80vw",
      height: "80vh",
      data: item,
      autoFocus: false,
    });
    this.matdialogRef.afterClosed().subscribe(() => {
      this.getDriversRoutes(this.searchtripID);
    });
  }

  getTripsList(selectedTripType: any) {
    this.loading = true;
    this.tripType = selectedTripType;
    this.fetch_page = 1;
    this.startPage = 1;
    this.document_array = [];
    this.getDriversRoutes(this.searchtripID);
  }

  GoToAllTrips() {
    this.allTrips = true;
    this.liveTrips = false;
  }

  GoToLiveTrips() {
    this.liveTrips = true;
    this.allTrips = false;
  }

  openSearch() {
    this.toggleSearch = true;
    this.searchButton = false;
    this.search_Btn = true;
    this.clear_Btn = false;
    if (this.toggleSearch) {
      setTimeout(() => {
        if (this.inputElement && this.inputElement.nativeElement) {
          this.inputElement.nativeElement.focus();
        }
      }, 0);
    }
  }

  search(value: any) {
    if (value && value !== "") {
      this.search_Btn = false;
      this.clear_Btn = true;
      this.startPage = 1;
      this.fetch_page = 1;
      this.getDriversRoutes(value);
    }
  }

  pagination(page_status: any) {
    let newPage = this.fetch_page;

    if (page_status === "-1") {
      newPage = Math.max(1, this.fetch_page - 1);
    } else if (page_status === "1") {
      newPage = this.fetch_page + 1;
    } else if (page_status === "first") {
      newPage = 1;
    } else if (page_status === "last") {
      newPage = this.last_page || 1;
    }

    this.fetch_page = newPage;
    this.currentPage = newPage;
    this.startPage = newPage;

    sessionStorage.setItem("lastToDriverOrdersFetchPage", newPage.toString());
    this.getDriversRoutes(this.searchtripID);
  }

  getTransporterTotalPaid(truckownerPaymentInfo: any[]): number {
    if (!truckownerPaymentInfo || !truckownerPaymentInfo.length) {
      return 0;
    }
    return truckownerPaymentInfo.reduce(
      (sum, p) => sum + (Number(p.transaction_amount) || 0),
      0
    );
  }

  getTransporterFare(item: any): number {
    if (!item) return 0;
    const userType =
      item.trip_details?.[0]?.userInfo?.user_type ||
      item.trip_details?.[0]?.userInfo?.[0]?.user_type;
    if (userType === "corporate") {
      const payAs = item.workorderInfo?.[0]?.pay_as_load_quantity;
      const otherDetails = item.tripInfo?.workOrderOtherDetails;
      const pricePerTon = Number(otherDetails?.price_per_ton) || 0;
      if (payAs === "loaded_quantity") {
        return (Number(otherDetails?.loading_point) || 0) * pricePerTon;
      } else if (payAs === "unloaded_quantity") {
        const qty =
          Number(otherDetails?.unloading_point) ||
          Number(otherDetails?.loading_point) ||
          0;
        return qty * pricePerTon;
      }
      return Number(item.total_fare) || 0;
    }
    return Number(item.total_fare) || 0;
  }
}
